var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle_page_top_menu_bar"},[(_vm.pageType != 'home')?_c('div',{staticClass:"left_div"},[_c('div',{staticClass:"back_btn",on:{"click":function($event){return _vm.pageBackClick()}}})]):_vm._e(),_c('div',{staticClass:"right_div"})])
}
var staticRenderFns = []

export { render, staticRenderFns }